module.exports = {"receivedInvitationsTitle":"Erhaltene Einladungen","sentInvitationsTitle":"Verschickte Einladungen","recipientColumnHeading":"Empfänger","senderColumnHeading":"Absender","actions":{"accept":"Annehmen","reject":"Ablehnen","cancel":"Einladung zurückziehen"},"status":{"accepted":"Angenommen","rejected":"Abgelehnt","cancelled":"Zurückgezogen"},"meta":"Einladungen"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/invitations.json
// module id = 8uML
// module chunks = 1